import $ from 'cash-dom'

export default class CommentForm {
  constructor({ $container }) {
    this.$container = $container

    this.constructElements()

    this.constructEvents()

    this.constructTextarea()
  }

  static init() {
    const $containers = $(CommentForm.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new CommentForm({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$textarea = this.$container.find(CommentForm.selectors.textarea)
    this.$clone = this.$container.find(CommentForm.selectors.clone)
  }

  constructEvents() {
    this.$container
      .on('input', CommentForm.selectors.textarea, (e) => this.handleInput({ e }))
  }

  constructTextarea() {
    this.lineLimit = 99

    this.textareaValue = this.getTextareaValue()

    this.updateTextareaValue = false
  }

  doFilter() {
    // double lines
    if (this.getDoubleLines() > 1) {
      this.textareaValue = this.textareaValue.replace(/\n\s*\n\s*\n/g, '\n')

      this.updateTextareaValue = true
    }

    // extra lines
    if (this.getLines() >= this.lineLimit) {
      const $split = this.textareaValue.split('\n')

      this.textareaValue = ($split.slice(0, this.lineLimit - 1).join('\n')) + ' ' + ($split.slice(this.lineLimit - 1, $split.length).join(' '))

      this.updateTextareaValue = true
    }
  }

  doUpdate() {
    // clone
    this.$clone.text(this.textareaValue)

    // textarea value
    if (this.updateTextareaValue) {
      this.$textarea.val(this.textareaValue)

      this.updateTextareaValue = false
    }
  }

  getDoubleLines() {
    return this.$textarea.val().split(/\n\s*\n\s*\n/).length
  }

  getLines() {
    return this.$textarea.val().split('\n').length
  }

  getTextareaValue() {
    return this.$textarea.val()
  }

  handleInput({ e }) {
    this.textareaValue = this.getTextareaValue()

    this.doFilter()

    this.doUpdate()

    if (this.getLines() == this.lineLimit && (e.keyCode || e.which) == 13) {
      return false
    }
  }
}

CommentForm.selectors = {
  container: '.js-comment-form',
  textarea: '.js-comment-form-textarea',
  clone: '.js-comment-form-textarea-clone',
}

CommentForm.classes = {

}
